import { useEffect } from 'react';
import heroSquareVersionMap from '@cbhq/cds-illustrations/__generated__/heroSquare/data/versionMap';

// HeroSquare illustrations BasicErrorFallback renders for the offline / retry
// branches. Pre-fetched at app startup so the images are in the browser cache
// and render even if the network is dead at the moment the error UI mounts.
// errorWeb500 is intentionally excluded — it only renders when the request
// reached the server, so we're online and can fetch the asset on demand.
const ASSET_NAMES = ['networkWarning', 'errorRefreshWeb'] as const;
const COLOR_SCHEMES = ['light', 'dark'] as const;

export function PrefetchErrorAssets() {
  useEffect(() => {
    const links: HTMLLinkElement[] = [];
    ASSET_NAMES.forEach((name) => {
      const version = heroSquareVersionMap[name];
      if (version == null) return;
      COLOR_SCHEMES.forEach((scheme) => {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = `https://static-assets.coinbase.com/ui-infra/illustration/v1/heroSquare/svg/${scheme}/${name}-${version}.svg`;
        document.head.appendChild(link);
        links.push(link);
      });
    });

    return () => {
      links.forEach((link) => link.remove());
    };
  }, []);

  return null;
}
